"use client";

import React from "react";
import s from "../styles";
import { useRouter } from "next/navigation";

export default function DetailTitleArea({ actions, isY_5, isY_5_label, isY_5_3, isY_6_2, isY_6_4, isY_7_2, quoteNumber, btflg, prevId = null }) {
  const router = useRouter();
  const backHref = prevId ? `/ordered/${prevId}` : `/ordered/Y-4-2`;
  let title = "見積をする";
  if (isY_5) {
    title = "見積をする";
  } else if (isY_5_label) {
    title = "見積をする";
  } else if (isY_5_3) {
    title = "見積をする";
  } else if (isY_6_2) {
    title = "受注確認";
  } else if (isY_6_4) {
    title = "受注処理中";
  } else if (isY_7_2) {
    if (btflg === 1) {
      title = "返品値引処理をする";
    } else {
      title = "完了分";
    }
  }
  console.log(`title: ${title} backHref: ${backHref}`);
  
  const onPrintRequest = (e) => {
    e.preventDefault();
    window.open(`/pdf/request/${quoteNumber}`, "_blank");
  };

  const onPrintOrder = (e) => {
    e.preventDefault();
    window.open(`/pdf/order/${quoteNumber}`, "_blank");
  };

  const onDownloadNohinsho = (e) => {
    e.preventDefault();
    window.open(`/pdf/nouhinsho/${quoteNumber}`, "_blank");
  };

  const RightActions = () => {
    const onBack = (e) => {
      e.preventDefault();
      // セッションストレージからデータを削除
      sessionStorage.removeItem(`orderedDetail_${quoteNumber}`);
      router.push(backHref);
    };
    const nodes = [];

    // Y-5: 依頼内容を印刷する + 戻る
    if (isY_5) {
      nodes.push(
        <s.ImportantBtn2 key="print-request" onClick={(e) => onPrintRequest(e)} _target="blank">
          依頼内容を印刷する
        </s.ImportantBtn2>
      );
    }

    // Y-6-4: 受注内容を印刷する + 戻る
    if (isY_6_4) {
      nodes.push(
        <s.ImportantBtn2 key="print-order" onClick={(e) => onPrintOrder(e)} _target="blank">
          受注内容を印刷する
        </s.ImportantBtn2>
      );
    }

    // Y-7-2: btflg==1 のとき 印刷 + 納品書DL + 戻る、btflg!=1 は戻るのみ
    if (isY_7_2 && btflg === 1) {
      nodes.push(
        <s.ImportantBtn2 key="print-order-y72" onClick={(e) => onPrintOrder(e)} _target="blank">
          受注内容を印刷する
        </s.ImportantBtn2>
      );
      nodes.push(
        <s.ImportantBtn2 key="nohinsho-dl" onClick={onDownloadNohinsho} _target="blank">
          納品書ダウンロード
        </s.ImportantBtn2>
      );
    }

    // Y-5-label, Y-5-3, Y-6-2 は印刷ボタンなし（戻るのみ）
    // 共通：最後に一覧へ戻る
    nodes.push(
      <s.ImportantBtn key="back" onClick={(e) => onBack(e)}>
        一覧へ戻る
      </s.ImportantBtn>
    );

    return (
      <span style={{ float: "right" }}>
        {nodes.map((n, i) => (
          <React.Fragment key={i}>
            {i > 0 ? <>&nbsp;</> : null}
            {n}
          </React.Fragment>
        ))}
      </span>
    );
  };

  return (
    <s.DetailTitle>
      {title}
      <RightActions />
    </s.DetailTitle>
  );
}
